<template>
  <div class="case">
    <div class="banner">
      <div class="title">客户成功</div>
      <div class="desc">
        <section>Customer success Stories</section>
      </div>
        <router-link target="_blank"  to='/contact'><div class="button">立即咨询<i class="el-icon-right"></i></div></router-link> 
    </div>
    <div class="caseTitle">
      部分案例
    </div>
    <div class="secondCase"  v-if="caseList.length>0">
      <div class="item" v-for="(item,index) in caseList" :key="index">
        <img :src="item.small_image" @click="goCase(item.id)">
      </div>
    </div>
    <div class="caseTitle">
      专家观点
    </div>
    <div class="talk">
      <swiper ref="mySwiper" :options="swiperOptions">
        <swiper-slide v-for="(item,index) in peopleList" :key="index">
          <div class="header">
            <img :src="`https://respool.isheji.com/isheji/static/qiye/image/home/${item.imageUrl}.png`">
            <div class="text">
              <div class="name">{{item.name}}</div>
              <div class="title">{{item.title}}</div>
              <div class="title" v-if="item.title1"> {{ item.title1 }}</div>
            </div>
          </div>
          <div class="footer">
            <div>{{item.textList.join('')}}</div>
          </div>
        </swiper-slide>
      </swiper>
      <div class="swiper-button-prev" slot="button-prev"><i class="el-icon-arrow-left"></i></div>
      <div class="swiper-button-next" slot="button-next"><i class="el-icon-arrow-right"></i></div>

    </div>
     <banner></banner>
  </div>
</template>
<script>

import 'swiper/dist/css/swiper.css'; 
import { getCase } from "@/config/axios/new_api";
import banner from '@/components/solutionBanner.vue'
export default {
  name: 'manage',
  components: {
    banner,
  },
  data() {
    return {
      swiperOptions: {
          width: 1200, 
          slidesPerView : 'auto',  
          navigation: {
            nextEl: '.swiper-button-next',
            prevEl: '.swiper-button-prev'
          }
          // Some Swiper option/callback...
        },
      peopleList: [
        {
          name: '柴继军',
          title: '视觉中国总裁',
          imageUrl: 'people_head_1',
          textList: [
            '从目前市场的实践来看，内容中台是企业',
            '内容数字化转型的最佳路径之一，视觉中',
            '国积极参与到内容中台的核心使命-优质内',
            '容生产中来，为客户提供优质海量、版权',
            '合规的图片、视频、音乐、字体等素材内',
            '容，全面赋能企业数字化内容营销。'
          ]
        },
        {
          name: '桑文峰',
          title: '神策数据创始人/CEO',
          imageUrl: 'people_head_2',
          textList: [
            '针对当下“数据+技术”双驱动的发展态势',
            '以及营销数字化时代的到来，内容中台应',
            '运而生。内容中台能够基于企业痛点，实',
            '现从生产、存储、审核、取用、分发、反',
            '馈等内容流转，更高效科学地设计和组织',
            '营销素材，驱动企业核心业务指标增长。'
          ]
        },
        {
          name: '赵充',
          title: '微梦传媒&爱设计创始人/CEO',
          imageUrl: 'people_head_3',
          textList: [
            '在流量趋势从增量到存量，精细化运营、',
            '降本增效成为企业营销转型的主旋律时，',
            '内容中台将是继CDP/MA 之后，拉动企业',
            '品牌增长的第三架马车。'
          ]
        },
        {
          name: '王浩',
          title: '流量池研究所联合创始人',
          title1: '瑞幸咖啡私域顾问',
          imageUrl: 'people_head_4',
          textList: [
            '移动互联网多元化垂直化的高速发展，线上',
            '线下消费链路的无缝打通已经构建了新的消',
            '费生态和消费习惯。在这种背景下，传统企',
            '业如何打破行业周期，爱设计内容中台给出',
            '了一份可落地的答卷，高度成熟化可配置的',
            '产品模块和开放接口，帮助企业以较低门槛',
            '布局数字化，以内容中台驱动组织协同和转',
            '化效率提升，实现销量的稳步增长。'
          ]
        },
        {
          name: '徐志斌',
          title: '见实科技创始人',
          imageUrl: 'people_head_5',
          textList: [
            '纵观许多品牌的私域发展，内容体现无处不在',
            '从欢迎话术到活动发起，从直播到短视频，从',
            '朋友圈到群内沟通，从一对一细聊到面对海量',
            '用户，好内容能让转化效果大增，而最稀缺的',
            '恰恰是无数环节中的优质内容，以及能让好内',
            '容同步到所有员工、每个用户、每个分销员、',
            '每个场景、每个触点中的内容中台。'
          ]
        },
        {
          name: '梅波',
          title: '弯弓Digital创始人',
          imageUrl: 'people_head_6',
          textList: [
            '在弯弓的五力增长模型中，内容力是企业数',
            '字化营销的核心能力，是实现产品推广、用',
            '户连接、渠道赋能和品牌建设的重要手段。',
            '而要保证内容的合规性、系统性、智创性，',
            '并实现千人千面分发管理、有效的标签化洞',
            '察，就需要部署内容中台系统。营销数字化',
            '时代，创建强大的内容力是每个伟大企业的',
            '必由之路。感谢爱设计的探索和付出！'
          ]
        },
        {
          name: '霍太稳',
          title: '极客邦科技创始人&CEO',
          title1: 'InfoQ中国创始人',
          imageUrl: 'people_head_7',
          textList: [
            '新经济持续发展，催生了大量新消费需求，同时',
            '也拓展了更多数字化的应用场景，对品牌的数字',
            '化营销提出了更高的挑战，大量的内容需求如何',
            '高效满足？内容数字化是必经之路。爱设计选择',
            '的赛道非常精深且艰难，但这正体现了它的责任',
            '感和目标感—通过数字化技术，为品牌内容营销',
            '提供科技赋能，促进内容效率的飞升。'
          ]
        },
        {
          name: '周再宇',
          title: '科特勒增长实验室内容专家',
          imageUrl: 'people_head_8',
          textList: [
            '在目前的存量竞争时代，内容营销能够帮助企',
            '业提高用户黏性，从而挖掘交易机会。但是，',
            '以往的内容创作与复用严重依赖于人工，具有',
            '一定的不确定性和不稳定性。内容中台通过数',
            '据收集和分析，辅助传播策划和内容生产，能',
            '够有效助力内容营销降本增效。'
          ]
        }
      ],
      caseList:[]
    };
  },
  created() {
    getCase().then((res)=>{
      if(res.data.status == 1){
        this.caseList = res.data.data;
      }
    })
  },
   computed: {
      swiper() {
        return this.$refs.mySwiper.$swiper
      }
  },
 
  methods: {
    goCase(id){
      this.$router.push({path: '/detail', query: {'id':id}});
    }
  },
}
</script>
<style lang="scss" scoped>
.case{
    width: 100%;
    min-width: 1400px;
    .banner{
      margin-bottom: 80px;
      text-align: center;
      background-image: url('https://respool.isheji.com/isheji/static/qiye/image/case/banner.png');
      width: 100%;
      min-width: 1400px;
      height: 460px;
      background-position-x: center;
      background-size: cover;
      position: relative;
      display: flex;
      flex-direction: column;
      justify-content: center;
      align-items: center;
      padding-top: 60px;
      .title{
        font-size: 32px;
        font-family: PingFangSC-Medium, PingFang SC;
        font-weight: 500;
        color: #FFFFFF;
        line-height: 45px;
      }
      .desc{
        margin-top: 20px;
        text-align: center;
        font-size: 16px;
        font-family: PingFangSC-Regular, PingFang SC;
        font-weight: 400;
        color: #FFFFFF;
        line-height: 22px;
        margin-bottom: 32px;
      }
     
    }
    .context{
      padding-top: 120px;
      width: 1200px;
      margin: auto;
      .row{
        display: flex;
        margin-bottom: 115px;
        .left{
          margin-left: 142px;
        }
        .right{
          margin-right: 142px;
        }
        .introduce{
          .iheader{
            display: flex;
            align-items: center;
            img{
              width: 60px;
              height: 60px;
              border-radius: 8px;
            }
            .iTitle{
              margin-left: 18px;
              display: flex;
              flex-direction: column;
              justify-content: center;
            
              .bold{
                font-size: 20px;
                font-family: PingFangSC-Medium, PingFang SC;
                font-weight: 500;
                color: #3B3946;
                line-height: 28px;
              }
              .thin{
                font-size: 14px;
                font-family: PingFangSC-Regular, PingFang SC;
                font-weight: 400;
                color: #9E9DA7;
                line-height: 20px;
              }
            }
          }
          .idesc{
            margin-top: 24px;
            font-size: 14px;
            font-family: PingFangSC-Regular, PingFang SC;
            font-weight: 400;
            color: #6E6C76;
            line-height: 20px;
            margin-bottom: 32px;
          }
        }
        .img{
          width: 595px;
        }
        
      }
    }
    .caseTitle{
      font-size: 32px;
      font-family: PingFangSC-Semibold, PingFang SC;
      font-weight: 600;
      color: #3B3946;
      line-height: 45px;
      margin-bottom: 48px;
      text-align: center;
    }
    .talk{
      margin: auto;
      width: 1200px;
      position: relative;
      height: 314px;
      display: flex;
      justify-content: center;
      align-items: center;
      margin-bottom: 80px;
      .swiper-slide {
          width: 333px;
          height: 314px;
          background: #F7F7FB;
          border-radius: 6px;
          margin-right: 34px;
          display: flex;
          flex-direction: column;
          
          &:last-child{
            margin-right: 0;
          }
          .header{
            background-image: url('https://respool.isheji.com/isheji/static/qiye/image/case/itemSubs.png') ;
            background-repeat: no-repeat;
            display: flex;
            align-items: center;
            height: 84px;
            background-position: 217px 13px;
            padding-left: 17px;
            .name {
              font-size: 16px;
              font-family: PingFangSC-Medium, PingFang SC;
              font-weight: 500;
              color: #3B3946;
            }
            .title {
              font-size: 14px;
              font-family: PingFangSC-Medium, PingFang SC;
              font-weight: 400;
              color: #6E6C76;
            }
            img{
              width: 48px;
              height: 48px;
              margin-right: 12px;
            }
          }
          .footer{
              background-image: url('https://respool.isheji.com/isheji/static/qiye/image/case/itemBanner.png') ;
              background-repeat: no-repeat;
              width: 317px;
              height: 222px;
              margin-left: 12px;
              background-color: #fff;
              display: flex;
              flex-direction: column;
              justify-content: center;
              align-items: center;
              font-size: 14px;
              font-family: PingFangSC-Regular, PingFang SC;
              font-weight: 400;
              color: #3B3946;
              line-height: 20px;
              padding: 0 20px;
          }
        }
        .swiper-button-next,.swiper-button-prev{
          width: 50px;
          height: 50px;
          background: #FFFFFF;
          box-shadow: 0px 8px 20px 0px rgba(59, 57, 70, 0.14);
          display: flex;
          justify-content: center;
          align-items: center;
          border-radius: 50%;
          font-size: 20px;
        }
        .swiper-button-prev{
          left: -20px;
        }
        .swiper-button-next{
          right: -20px;
        }
    }
    .secondCase{
      width: 1200px;
      margin: auto;
      display: flex;
      flex-wrap: wrap;
      .item{
        width: 384px;
        height: 358px;
        background: #FFFFFF;
        margin-right: 24px;
        margin-bottom: 40px;
        cursor: pointer;
        overflow: hidden;
        border-radius: 8px;
        border: 1px solid #E9E9ED;
        &:nth-child(3n){
          margin-right: 0;
        }
        img{
          width: 100%;
        }
        &:hover{
            box-shadow: 0px 12px 24px 0px rgba(0, 0, 0, 0.1);
        }
      }
    }

     .button{
        width: 126px;
        height: 44px;
        background: #5A2DF5;
        border-radius: 4px;
        display: flex;
        justify-content: center;
        align-items: center;
        font-size: 14px;
        font-family: PingFangSC-Medium, PingFang SC;
        font-weight: 500;
        color: #FFFFFF;
        line-height: 20px;
        cursor: pointer;
          .el-icon-right{
            display: none;
            margin-left: 8px;
            color: #FFFFFF;
          }
        &:hover{
          .el-icon-right{
            display: block;
            margin-left: 8px;
            color: #FFFFFF;
          }
        }
      }
}
</style>